module.exports = __webpack_public_path__ + "img/MDI-lightbulb-on-outline.2cc535c2.svg";